import React, { useCallback, useMemo } from 'react';
import { ConfigureWriteBackLeverAuthMethod } from 'apps/sigma2-ui/src/components/workflows/ConfigureWriteBackLeverAuthMethod';
import { ConfigureWorkflowBaseProps } from 'apps/sigma2-ui/src/components/workflows/types';
import { WorkflowPlaces } from 'apps/sigma2-ui/src/components/workflows/WorkflowPlaces';
import { ConfigureWriteBackLeverPlaceToWrite } from 'apps/sigma2-ui/src/components/workflows/ConfigureWriteBackLeverPlaceToWrite';
import { WriteBackToLeverAuthMethod } from 'libs/end-to-end/src/types/databases/workflows/strategies/lever-write-back';
import { WriteBackToLeverPlaceToWrite } from 'libs/end-to-end/src/types/databases/workflows/strategies/lever-write-back';
import { WriteBackToLeverStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/lever-write-back';

export interface ConfigureWriteBackLeverStrategyProps
  extends ConfigureWorkflowBaseProps {
  strategy: WriteBackToLeverStrategy | null;

  updateStrategy: (strategy: WriteBackToLeverStrategy | null) => void;
}

export const ConfigureWriteBackLeverStrategy = ({
  strategy,
  updateStrategy,
  listSecretsPattern,
  organizationId,
  listDataSetsPattern,
}: ConfigureWriteBackLeverStrategyProps) => {
  const updateAuthMethod = useCallback(
    (authMethod: WriteBackToLeverAuthMethod | null) => {
      updateStrategy({
        type: 'lever',
        ...strategy,
        authMethod: authMethod ?? undefined,
      });
    },
    [strategy, updateStrategy],
  );

  const selectedAuthMethod = useMemo(
    () => strategy?.authMethod ?? null,
    [strategy?.authMethod],
  );

  const updatePlacesToWrite = useCallback(
    (placesToWrite: WriteBackToLeverPlaceToWrite[]) => {
      updateStrategy({
        type: 'lever',
        ...strategy,
        placesToWrite,
      });
    },
    [strategy, updateStrategy],
  );

  const selectedPlacesToWrite = useMemo(
    () => strategy?.placesToWrite ?? [],
    [strategy?.placesToWrite],
  );

  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <h2 className="text-xl font-semibold">Configure Lever Strategy</h2>
      <p className="text-gray-600">
        Configure the strategy for writing back the hiring readiness
        score/explanation to Lever.
      </p>
      <ConfigureWriteBackLeverAuthMethod
        authMethod={selectedAuthMethod}
        updateAuthMethod={updateAuthMethod}
        listSecretsPattern={listSecretsPattern}
        organizationId={organizationId}
        listDataSetsPattern={listDataSetsPattern}
      />
      <WorkflowPlaces
        updatePlacesToWrite={updatePlacesToWrite}
        placesToWrite={selectedPlacesToWrite}
        placeToWriteComponent={({ setNewPlaceToWrite, newPlaceToWrite }) => (
          <ConfigureWriteBackLeverPlaceToWrite
            placeToWrite={newPlaceToWrite}
            updatePlaceToWrite={setNewPlaceToWrite}
          />
        )}
      />
    </div>
  );
};
